/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { handleNetworkError } from '@/auth/lib/network-error';
import { fetchGraphQl } from '../fetch-graphql';
import { REQUEST_PASSWORD_RESET_EMAIL } from './graphql/requestPasswordResetEmail.graphql';
import { transformPasswordResetEmail } from '@/auth/data/transforms';
import { PasswordResetEmailModel } from '@/auth/data/models';
import { setReCaptchaToken } from '@/auth/lib/setReCaptchaToken';

export const requestPasswordResetEmail = async (
  email: string
): Promise<PasswordResetEmailModel> => {
  await setReCaptchaToken();

  return await fetchGraphQl(REQUEST_PASSWORD_RESET_EMAIL, {
    method: 'POST',
    variables: { email },
  })
    .then((response) => {
      return transformPasswordResetEmail(response);
    })
    .catch(handleNetworkError);
};
